import React, { useMemo } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logOutUser } from "../../../dux/login";
import {
  destroySession,
  getName,
  isAuthorized,
} from "../../../helpers/sessionStorageHelper";
import styles from "./LoginPanel.module.css";

const LoginPanel = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const name = getName();

  const signout = () => {
    dispatch(logOutUser());
    destroySession();
    navigate("/");
  };

  const goToAllBookingPage = () => {
    navigate("booking-records");
  };

  const goToMyAccount = () => {
    navigate("my-account/profile");
  };

  const goToMarkDays = () => {
    navigate("/mark-date-off-or-holiday");
  };

  const goToBlockSlots = () => {
    navigate("/block-slots");
  };

  const gotToGeneralRatesSetting = () => {
    navigate("admin-portal/general-rates");
  };

  // Use useMemo to create unique menu items based on user permissions
  const menuItems = useMemo(() => {
    const items = new Set();

    // Add "My Account" for all users
    items.add({
      id: "my-account",
      text: "My Account",
      onClick: goToMyAccount,
      icon: "nameInitial",
      iconContent: name[0],
      className: styles.nameInitial,
    });

    // Add "View All Bookings" for ADMIN_VIEW_ONLY, ADMIN, and SUPER_ADMIN
    if (
      isAuthorized("ADMIN_VIEW_ONLY") ||
      isAuthorized("ADMIN") ||
      isAuthorized("SUPER_ADMIN")
    ) {
      items.add({
        id: "view-all-bookings",
        text: "View All Bookings",
        onClick: goToAllBookingPage,
        icon: "pageIcon",
        iconContent: null,
      });
    }

    // Add "Block/Unblock Slots" for ADMIN and SUPER_ADMIN
    if (isAuthorized("ADMIN") || isAuthorized("SUPER_ADMIN")) {
      items.add({
        id: "block-slots",
        text: "Block/Unblock Slots",
        onClick: goToBlockSlots,
        icon: "arrowIcon",
        iconContent: null,
      });
    }

    // Add "Mark days Off/Holiday" for ADMIN and SUPER_ADMIN
    if (isAuthorized("ADMIN") || isAuthorized("SUPER_ADMIN")) {
      items.add({
        id: "mark-days",
        text: "Mark days Off/Holiday",
        onClick: goToMarkDays,
        icon: "arrowIcon",
        iconContent: null,
      });
    }

    // Add "Settings" only for SUPER_ADMIN
    if (isAuthorized("SUPER_ADMIN")) {
      items.add({
        id: "settings",
        text: "Settings",
        onClick: gotToGeneralRatesSetting,
        icon: "settingsIcon",
        iconContent: null,
      });
    }

    // Add "Logout" for all users
    items.add({
      id: "logout",
      text: "Logout",
      onClick: signout,
      icon: "signoutIcon",
      iconContent: null,
      testId: "signoutRow",
    });

    return Array.from(items);
  }, [name]);

  const renderIcon = (item) => {
    if (item.icon === "nameInitial") {
      return <span className={item.className}>{item.iconContent}</span>;
    }
    return <span className={styles[item.icon]} />;
  };

  return (
    <div className={styles.container}>
      {menuItems.map((item) => (
        <div
          key={item.id}
          data-testid={item.testId}
          className={styles.row}
          onClick={item.onClick}
        >
          {renderIcon(item)}
          <span className={styles.text}>{item.text}</span>
        </div>
      ))}
    </div>
  );
};

export default LoginPanel;
